//Regex
const regNombrePropio = /^([^0-9]+)$/;
const regTitulo = /^(?!\s*$)/;
const regNoControl = /^[0-9]{8}$/;
const regRFC = /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([A-Z\d]{3}))?$/;
const regRol = /^\b(auxiliar|personal|administrador)\b$/
const regResolucion = /^\b(200|300|400|600|1200)$/

//No Control
const validar_noControl = (valor) =>{
    if(!regNoControl.test(valor)){
        return "Numero de control invalido"
    }else{ 
        return null
    }
}
 
const validar_nombre = (valor) =>{
    if(!regNombrePropio.test(valor)){
        return "Nombre invalido"
    }else{ 
        return null
    }
}

const validar_ap_paterno = (valor) =>{
    if(!regNombrePropio.test(valor)){
        return "Apellido paterno invalido"
    }else{ 
        return null
    }
}

const validar_ap_materno = (valor) =>{
    if(!regNombrePropio.test(valor)){
        return "Apellido materno invalido"
    }else{
        return null
    }
}

const validar_usuario = (valor) =>{
    if(!regNombrePropio.test(valor)){
        return "Nombre de usuario invalido"
    }else{
        return null
    }
}

const validar_rfc = (valor) =>{
    if(!regRFC.test(valor)){
        return "Formato RFC invalido"
    }else{
        return null
    }
}

const validar_rol = (valor) =>{
    if(!regRol.test(valor)){
        return "Rol invalido"
    }else{
        return null
    }
}

const validar_lista = (valor) =>{
    if(Array.from(valor).length === 0){
        return "Lista vacia"
    }else{
        return null
    }
}

const validar_titulo = (valor) => {
    if(!regTitulo.test(valor)){
        return "Nombre invalido"
    }else{
        return null
    }
}

const validar_resolucion = (valor) => {
    if(!regResolucion.test(valor)){
        return "Resolucion invalida"
    }else{
        return null
    }
}

const sinErrores = (errors) =>{    
    if(Object.keys(errors).length === 0){
      return true;  
    }else {
        return false;
    }
}

module.exports = {
    validar_noControl,
    validar_nombre,
    validar_ap_paterno,
    validar_ap_materno,
    validar_usuario,
    validar_rfc,
    validar_rol,
    validar_lista,
    validar_titulo,
    validar_resolucion,
    sinErrores
}

 